import { useEffect, useState } from 'react';
import { AtmsApiClient } from '@amzn/et-console-components';

export interface ScoringModel {
  id:
    | {
        id: string;
        scope: string;
      }
    | string;
  name: string;
  threshold: number;
  frameworkType?: 'MQM1' | 'MQM2';
}

const scoringModelKey = (model: ScoringModel): string =>
  typeof model.id === 'string' ? model.id : `${model.id.scope}/${model.id.id}`;

/**
 * Returns the scoring models that can be picked for a workflow step: every model except MQM1 ones,
 * which can no longer be used in new projects. A model in selectedIds stays in the list even if it
 * is MQM1, so a step that already uses it still shows its current value.
 */
export const selectableScoringModels = (
  scoringModels: ScoringModel[],
  selectedIds: string[]
): ScoringModel[] =>
  scoringModels.filter(
    model => model.frameworkType !== 'MQM1' || selectedIds.includes(scoringModelKey(model))
  );

interface State {
  isLoadingScoringModels: boolean;
  scoringModels: ScoringModel[];
  scoringModelsById: { [id: string]: ScoringModel };
}

// TODO: Needs to reload models when the user profile changes
export const useScoringModels = (): State => {
  const [state, setState] = useState<State>({
    isLoadingScoringModels: true,
    scoringModels: [],
    scoringModelsById: {},
  });
  useEffect(() => {
    AtmsApiClient.httpGet('/api/scoring/getAllScoringModels').then(result => {
      setState({
        isLoadingScoringModels: false,
        scoringModels: result,
        scoringModelsById: result.reduce((acc, val) => {
          acc[val.id] = val;
          return acc;
        }, {}),
      });
    });
  }, []);

  return state;
};
